// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2KnXK","header":"PatientQuestionnaire_header__5bquP","info":"PatientQuestionnaire_info__WbQyl"};